import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '📄',
    text: '100% PDF'
  }, {
    icon: '🇦🇷',
    text: 'Material Argentino'
  }, {
    icon: '⚡',
    text: 'Acceso Inmediato'
  }];
  return <section className="relative bg-slate-950 text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-151">
      {/* Background gradient blobs */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-152">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-cyan-700/15 blur-[120px]" data-id="element-153"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-cyan-500/10 blur-[100px]" data-id="element-154"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-155">
        <div className="max-w-4xl mx-auto text-center mt-[-50px]" data-id="element-156">
          {/* Brand mark */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-cyan-400 font-bold tracking-wide items-center justify-center mb-6 pt-[0px] mt-[0px]" data-id="element-157">
            🇦🇷 CENTRALPACK™
          </motion.div>

          {/* Massive headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-2 text-balance text-[20px] mt-[-20px]" data-id="element-158">
            Todo tu material ABA.
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-10 text-cyan-400 text-balance text-[18px]" data-id="element-159">
            Listo. Desde hoy.
          </motion.h2>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-xs sm:max-w-sm mx-auto mb-10" data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/w93XVQUtBmVC5yh38c4S4J/0522.png" alt="CentralPack MegaPack ABA Listo - Terapia ABA Argentina" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(34,211,238,0.3)] mt-[-40px]" data-id="element-161" />
          </motion.div>

          {/* Tagline in accent color */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="md:text-xl font-bold text-cyan-400 mb-6 text-balance text-[14px] mt-[-50px]" data-id="element-162">
            El sistema N°1 de recursos clínicos ABA para profesionales
            argentinos
          </motion.p>

          {/* Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center mb-[30px] gap-[2px]" data-id="element-163">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-slate-900/80 border border-cyan-900/60 font-semibold backdrop-blur-sm text-[12px]" data-id="element-164">
                <span data-id="element-165">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-166">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-cyan-600 hover:bg-cyan-500 text-white font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(8,145,178,0.7)] hover:shadow-[0_15px_50px_-10px_rgba(8,145,178,0.9)] transition-all hover:-translate-y-1 md:text-base text-[12px] pt-[20px] mt-[-80px]" data-id="element-167">
              QUIERO MI CENTRALPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-168" />
            </button>
          </motion.div>

          {/* Trust signals */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-slate-400 font-medium" data-id="element-169">
            <div className="flex items-center gap-1.5" data-id="element-170">
              <Shield className="w-4 h-4 text-emerald-400" data-id="element-171" />
              <span data-id="element-172">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <Lock className="w-4 h-4 text-emerald-400" data-id="element-174" />
              <span data-id="element-175">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-176">
              <CreditCard className="w-4 h-4 text-cyan-400" data-id="element-177" />
              <span data-id="element-178">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}